module.exports = __webpack_public_path__ + "static/media/playstore-4a.5c8b9254.png";